import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Router } from '@angular/router';
import { Events, MessageService } from 'src/app/core/services';
import { SortConfig } from 'src/app/shared/view-models/sort-config';
import { CsrTasksView } from '../_models';
import { CsrTasksService, ViewStateService } from '../_services';

@Component({
	selector: 'st-csr-tasks-table',
	templateUrl: './csr-tasks-table.component.html'
})
export class CsrTasksTableComponent {
	@Input() byClientSearchResults: CsrTasksView[] = [];
	@Input() getTasks: () => void;
	@Input() getSortIconClass: (column: string) => string;
	@Input() sortConfig: SortConfig;
	@Input() tasks: CsrTasksView[] = [];
	@Output() handleSortClick: EventEmitter<SortConfig> = new EventEmitter();
	@Output() handlePaginationClick: EventEmitter<any> = new EventEmitter();

	get byClientRouteAndSearchActive(): boolean {
		let state = this.viewStateService.state;
		if (state.route === 'by-client' && state.searchTerm.length > 0) {
			return true;
		}
		return false;
	}

	constructor(
		public csrTasksService: CsrTasksService,
		private messageService: MessageService,
		private router: Router,
		public viewStateService: ViewStateService
	) {}

	public onEditClick(task: CsrTasksView): void {
		this.router.navigate([`system-tools/csr-tasks/edit-task/${task.Id}`]);
	}

	public onCompleteClick(task: CsrTasksView): void {
		if (!task.CompleteDate) {
			task.CompleteDate = new Date().toISOString();
			task.Completed = true;
			this.updateTask(task);
			this.csrTasksService.postHistoryNote(task).subscribe();
		} else {
			task.CompleteDate = null;
			task.Completed = false;
			this.updateTask(task);
		}
	}

	public onPageChange(): void {
		this.handlePaginationClick.emit(this.viewStateService.state.pageNumber);
	}

	public onClientNameClick(task: CsrTasksView): void {
		localStorage.setItem('changeClientUrl', `/crm/client-details/locations/`);
		window.open(`/my-products/${task.ClientId}`);
	}

	public onDeleteClick(task: CsrTasksView): void {
		const confirmOk: boolean = confirm(`Delete task "${task.Subject}"?`);
		if (confirmOk) {
			this.messageService.publish(Events.savingPreloader, 1);
			this.csrTasksService.deleteTask(task).subscribe(() => {
				this.getTasks();
				this.messageService.publish(Events.savingPreloader, 0);
			});
		}
	}

	private updateTask(task: CsrTasksView): void {
		this.messageService.publish(Events.savingPreloader, 1);
		this.csrTasksService.updateTask(task).subscribe(() => {
			this.getTasks();
			this.messageService.publish(Events.savingPreloader, 0);
		});
	}
}
